import OnboardingTour from '@/components/common/OnboardingTour/components/OnboardingTour';
import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import AnalysisSection from '@/features/analysis/components/AnalysisSection';
import CheckUp from '@/features/party/components/CheckUp/CheckUp';
import PartySection from '@/features/party/components/PartySection/PartySection';

import useEmailClient from '../email/hooks/useEmailClient';

import ComposeSection from './components/ComposeSection/ComposeSection';
import NoEmailSelected from './components/NoEmailSelected';
import NotReplying from './components/NotReplying';

export default function AssistantTab() {
  const { isEmailSelected } = useEmail();
  const { mode } = useEmailClient();

  return (
    <>
      <div className="flex h-full grow flex-col">
        {!isEmailSelected && (
          <>
            {mode === 'Compose' && <NotReplying />}
            {mode === 'Read' && <NoEmailSelected />}
          </>
        )}

        {isEmailSelected && (
          <div className="flex flex-col">
            <PartySection />

            <AnalysisSection />

            {mode === 'Compose' && <ComposeSection />}

            <CheckUp />
          </div>
        )}
      </div>
      <OnboardingTour />
    </>
  );
}
